import React from "react";

class None extends React.Component {

    focus = () => {
    }

    hide = () => {
    }

    render() {
        return null;
    }

}

export default None;